import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { textStyles } from '../foundations/textStyles'

const baseStyle = {
  fontWeight: 'semibold',
}

const variantEyebrow = {
  ...textStyles['eyebrow'],
  color: 'hb-body-text',
}

const variants = {
  eyebrow: variantEyebrow,
}

const sizes = {
  '2xs': defineStyle({
    ...textStyles['xs'],
  }),
  xs: defineStyle({
    ...textStyles['sm'],
  }),
  sm: defineStyle({
    ...textStyles['md'],
  }),
  md: defineStyle({
    ...textStyles['lg'],
  }),
  lg: defineStyle({
    ...textStyles['xl'],
  }),
  xl: defineStyle({
    ...textStyles['2xl'],
  }),
  '2xl': defineStyle({
    ...textStyles['3xl'],
  }),
  '3xl': defineStyle({
    ...textStyles['4xl'],
  }),
  '4xl': defineStyle({
    ...textStyles['5xl'],
  }),
}

export const Heading = defineStyleConfig({
  baseStyle,
  variants,
  sizes,
  defaultProps: {
    size: 'md',
  },
})
